import { token } from '@atlaskit/tokens';
import {
	type DevInfoType,
	DevInfoTypes,
} from '@atlassian/jira-development-board-common/src/types.tsx';
import type { ReviewState } from '@atlassian/jira-development-details-loader/src/common/types/index.tsx';
import type {
	JiraPullRequestState,
	JiraReviewState,
} from './__generated__/development_softwareReleasesVersionDetailIssueList.graphql';

export const mapPullRequestStateToIconColour = (state: JiraPullRequestState) => {
	switch (state) {
		case 'MERGED':
			return token('color.icon.success');
		case 'DECLINED':
			return token('color.icon.danger');
		default:
			return token('color.icon');
	}
};

export const mapReviewStateToIconColour = (state: JiraReviewState) => {
	switch (state) {
		case 'REVIEW':
			return token('color.icon');
		case 'APPROVAL':
			return token('color.icon');
		case 'SUMMARIZE':
			return token('color.icon');
		case 'REJECTED':
			return token('color.icon.danger');
		case 'CLOSED':
			return token('color.icon.success');
		case 'DRAFT':
			return token('color.icon');
		case 'DEAD':
			return token('color.icon.danger');
		case 'UNKNOWN':
			return token('color.icon.danger');
		default:
			return token('color.icon');
	}
};

export const toReviewState = (state: JiraReviewState): ReviewState => {
	switch (state) {
		case 'REVIEW':
		case 'APPROVAL':
		case 'SUMMARIZE':
		case 'REJECTED':
		case 'CLOSED':
		case 'DRAFT':
		case 'DEAD':
			return state;
		default:
			return 'UNKNOWN';
	}
};

export const toDevInfoType = (state: JiraPullRequestState): DevInfoType => {
	switch (state) {
		case 'DECLINED':
			return DevInfoTypes.DECLINED;
		case 'MERGED':
			return DevInfoTypes.MERGED;
		default:
			return DevInfoTypes.PULLREQUEST;
	}
};
